import Vue from 'vue'
import VueTheMask from 'vue-the-mask'
import Toasted from 'vue-toasted'
import Vuelidate from 'vuelidate'
import appLink from './apilink'
import VueSmoothScroll from 'vue2-smooth-scroll'
import VueHead from 'vue-head'
import VTooltip from 'v-tooltip'
import moment from 'moment'
import PerfectScrollbar from 'vue2-perfect-scrollbar'

import 'moment/locale/uk'
import 'moment/locale/ru'
import 'vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css'

//use
Vue.use(Toasted, {
  duration: 3000,
  position: 'top-right',
})
Vue.use(appLink)
Vue.use(VueTheMask)
Vue.use(Vuelidate)
Vue.use(require('vue-moment'))
Vue.use(VTooltip)
Vue.use(PerfectScrollbar);
Vue.use(VueSmoothScroll, {
  duration: 400,
  offset: -380,
})
Vue.use(VueHead)
Vue.prototype.moment = moment
